import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTiles } from './Tiles.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTiles({ prefix }));
}
